// ================================================================================================
// lodash
import _ from "lodash";
// React components
import * as React from "react";

// Nested-List for Re-Ordering
import { flatMap } from './NestedListUtils';
import { NestedList, NestedListItem } from './NestedList';
import * as  Immutable from 'immutable';

import { FolderStructure, FolderItemType } from "./TreeStructure";
import ListItem from "./MUI/ListItem";
// ================================================================================================
export interface ReorderTreeStructureProps extends React.Props<ReorderTreeStructure> {
    ReorderStructure: FolderStructure[];
    onTreeDataChange: (tree: any) => void;
}
// ------------------------------------------------------------------------------------------------
export interface ReorderTreeStructureState {
    randomKey: string;
    ReorderStructure: FolderStructure[];
    TreeObject: any;
}
// ------------------------------------------------------------------------------------------------
export class ReorderTreeStructure extends React.Component<ReorderTreeStructureProps, ReorderTreeStructureState> {
    constructor(props: ReorderTreeStructureProps) {
        super(props);
        this.state = {
            randomKey: "ReOrder-Tree-Structure-" + (Math.random() * 10000).toString(),
            ReorderStructure: _.cloneDeep(this.props.ReorderStructure),
            TreeObject: Immutable.fromJS(this.props.ReorderStructure)
        };
    }
    // ---------------------------------------------------------------------------------------------------
    render() {
        return (
            <NestedList
                key={"nested-list"}
                data={this.state.TreeObject}
                onDataChange={this.props.onTreeDataChange}
                validate={(tree) => this.validateFolderStructureRules(tree.toJS())}
                getChildren={(items, draggedId) => (
                    <div className="list" style={{ background: "lightgray" }}>
                        {flatMap(items, item => {
                            let itemJS = item.toJS();
                            return <NestedListItem key={"nested-list-" + item.get('_id')} item={item}>
                                <div
                                    style={{ paddingLeft: (item.get('__level') - 1) * 25 + 10 }}
                                    className={'list-item' + (draggedId === item.get('_id') ? ' list-item-preview' : '')}>
                                    <div style={{ background: "white" }}>
                                        <ListItem
                                            key={"nested-list-item-" + item.get('_id')}
                                            primaryText={itemJS.primaryText}
                                            leftIcon={itemJS.leftIcon}
                                            rightIcon={itemJS.rightIcon}
                                            secondaryText={itemJS.secondaryText}
                                            style={itemJS.style}
                                        />
                                    </div>
                                </div>
                            </NestedListItem>
                        }
                        )}
                    </div>
                )}
            />);
    }
    // ---------------------------------------------------------------------------------------------------
    componentDidUpdate(propProps: ReorderTreeStructureProps) {
        if (!_.isEqual(propProps.ReorderStructure, this.props.ReorderStructure))
            this.setState({
                ReorderStructure: _.cloneDeep(this.props.ReorderStructure),
                TreeObject: Immutable.fromJS(this.props.ReorderStructure)
            });
    }
    // ---------------------------------------------------------------------------------------------------
    private validateFolderStructureRules(structure: FolderStructure[]): boolean {
        var res: boolean = true;
        structure.forEach(element => {
            if (element.type != FolderItemType.Folder && element.children.length > 0) {
                res = false;
            }
            else if (element.children.length > 0) {
                if (!this.validateFolderStructureRules(element.children))
                    res = false;
            }
        });
        return res;
    }
    // ---------------------------------------------------------------------------------------------------

}
// ---------------------------------------------------------------------------------------------------
